import { render, staticRenderFns } from "./imagem-avatar.vue?vue&type=template&id=0c144984"
import script from "./imagem-avatar.vue?vue&type=script&lang=ts"
export * from "./imagem-avatar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports